import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=0c0cd2ed&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0cd2ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0cd2ed')) {
      api.createRecord('0c0cd2ed', component.options)
    } else {
      api.reload('0c0cd2ed', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=0c0cd2ed&scoped=true&", function () {
      api.rerender('0c0cd2ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VtYdbUfLaRQf/JS/comp/Accordion.vue"
export default component.exports